export default "__VITE_ASSET__Bsi9MqT7__"